import React from "react";
import { Heart } from "lucide-react";
import { useFavorites } from "../context/FavoritesContext";

export default function FavHeart({ kind, ref_id, title, image, payload, size = 16, testid }) {
  const { isFav, toggle } = useFavorites();
  const active = isFav(kind, ref_id);
  return (
    <button
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); toggle({ kind, ref_id: String(ref_id), title, image, payload }); }}
      data-testid={testid || `fav-${kind}-${ref_id}`}
      className={`p-2 border transition-all ${active ? "border-[color:var(--sat-cyan)] text-[color:var(--sat-cyan)] bg-[color:var(--sat-cyan-soft)]" : "border-[color:var(--sat-border)] text-[color:var(--sat-text-dim)] hover:border-[color:var(--sat-cyan)] hover:text-[color:var(--sat-cyan)]"}`}
      aria-label={active ? "Remove from archive" : "Add to archive"}>
      <Heart size={size} fill={active ? "currentColor" : "none"} strokeWidth={1.5} />
    </button>
  );
}
